import { createOnboardingStore } from './create-onboarding-store';

const useFreelancerStore = createOnboardingStore('kyb_freelancer_draft', 2);

export { useFreelancerStore };
